<template>
  <div>
    <div v-if="done" class="card">
      <div class="card-body">
        <b-container fluid>
          <b-form @submit="onSubmit">
            <input type="hidden" id="dataItem-id-hidden" v-model="dataItem.id" />
            <b-form-group label="Shipping Provider Id">
              <shipping-providers @change="onchange" :initialValue="dataItem.shippingProviderId" />
              <!-- <b-form-input
                  type="text"
                  id="dataItem-shippingProviderId-input"
                  class="form-input"
                  v-model="dataItem.shippingProviderId"
                  @blur="$v.dataItem.shippingProviderId.$touch()"
              ></b-form-input> -->
              <div class="invalid-feedback">
                <div v-if="!$v.dataItem.shippingProviderId.required">Shipping Provider Id is required</div>
              </div>
            </b-form-group>
            <b-form-group label="Name">
              <b-form-input
                type="text"
                id="dataItem-name-input"
                class="form-input"
                v-model="dataItem.name"
                @blur="$v.dataItem.name.$touch()"
              ></b-form-input>
              <div class="invalid-feedback">
                <div v-if="!$v.dataItem.name.required">Name is required</div>
              </div>
            </b-form-group>
            <b-form-group label="Shipping Days">
              <b-form-input
                type="text"
                id="dataItem-shippingDays-input"
                class="form-input"
                v-model="dataItem.shippingDays"
                @blur="$v.dataItem.shippingDays.$touch()"
              ></b-form-input>
              <div class="invalid-feedback">
                <div v-if="!$v.dataItem.shippingDays.required">Shipping Days is required</div>
              </div>
            </b-form-group>
            <b-form-group label="Shipping Account">
              <b-form-input
                type="text"
                id="dataItem-shippingAccount-input"
                class="form-input"
                v-model="dataItem.shippingAccount"
                @blur="$v.dataItem.shippingAccount.$touch()"
              ></b-form-input>
              <div class="invalid-feedback">
                <div v-if="!$v.dataItem.shippingAccount.required">Shipping Account is required</div>
              </div>
            </b-form-group>
            <!-- <b-form-group label="Q BSynced">
              <b-form-input
                type="text"
                id="dataItem-qBSynced-input"
                class="form-input"
                v-model="dataItem.qBSynced"
                @blur="$v.dataItem.qBSynced.$touch()"
              ></b-form-input>
              <div class="invalid-feedback">
                <div v-if="!$v.dataItem.qBSynced.required">Q BSynced is required</div>
              </div>
            </b-form-group>
            <b-form-group label="Q BShip Via Name">
              <b-form-input
                type="text"
                id="dataItem-qBShipViaName-input"
                class="form-input"
                v-model="dataItem.qBShipViaName"
                @blur="$v.dataItem.qBShipViaName.$touch()"
              ></b-form-input>
              <div class="invalid-feedback">
                <div v-if="!$v.dataItem.qBShipViaName.required">Q BShip Via Name is required</div>
              </div>
            </b-form-group>
            <b-form-group label="Q BShip Via List ID">
              <b-form-input
                type="text"
                id="dataItem-qBShipViaListID-input"
                class="form-input"
                v-model="dataItem.qBShipViaListID"
                @blur="$v.dataItem.qBShipViaListID.$touch()"
              ></b-form-input>
              <div class="invalid-feedback">
                <div v-if="!$v.dataItem.qBShipViaListID.required">Q BShip Via List ID is required</div>
              </div>
            </b-form-group>
            <b-form-group label="Active">
              <b-form-checkbox
                id="dataItem-active-input"
                class="form-input"
                v-model="dataItem.active"
              >Active</b-form-checkbox>
            </b-form-group> -->

            <b-button type="submit" variant="primary" style="margin: 5px;">Save</b-button>
            <b-button style="margin: 5px;" @click="cancel">Cancel</b-button>
          </b-form>
        </b-container>
          
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import service from '../../service';
import { ShippingMethodDto } from '../../dto';
import ShippingProviders from '@/shared/components/ShippingProviders';

export default {
  components: {
    ShippingProviders,
  },
  data: () => ({
    done: false,
    dataItem: {},
  }),
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  methods: {
    async onSubmit(e) {
      e.preventDefault();

      this.$v.dataItem.$touch();
      if (this.$v.dataItem.$invalid) {
        return;
      }

      let payload = new ShippingMethodDto(this.dataItem);

      try {
        const id = await service.updateShippingMethod(payload);
        this.redirectToListing();
      } catch {}
    },
    cancel() {
      this.redirectToListing();
    },
    redirectToListing() {
      this.$router.push({ name: 'ShippingMethods' });
    },
    onchange(e) {
      this.dataItem.shippingProviderId = e;
    },
  },
  mounted() {
    this.done = false;
    this.setContainerLoader(true);
    service.getShippingMethodById(this.id).then((data) => {
      this.setContainerLoader(false);
      this.dataItem = data;
      this.done = true;
    }).catch(() => {
      this.setContainerLoader(false);
      //return back to listing page because error in fetch record
      this.$router.push({name: 'ShippingMethods'});
    });
  },
  validations: {
    dataItem: {
      id: {},
      shippingProviderId: {},
      name: {},
      shippingDays: {},
      shippingAccount: {},
      qBSynced: {},
      qBShipViaName: {},
      qBShipViaListID: {},
      createdByUserId: {},
      modifiedByUserId: {},
      dateCreated: {},
      dateModified: {},
      active: {},
    },
  },
};
</script>
